<script>
import { cloneDeep } from 'lodash';
import DatePicker from "vue2-datepicker";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import FeeModal from "@/components/modals/fee-template-modal.vue";
import BillingList from "./unpaid-billing-list.vue";
import { required } from "vuelidate/lib/validators";

export default {
    name: 'CollectionModal',
    components: {
        DatePicker,
        MaskedInput,
        FeeModal,
        BillingList
    },
    props: {
        modalTitle: {
            type: String,
            default: 'Collection Modal'
        },
        fees: {
            type: Array,
            default: () => []
        },
        fundSources: {
            type: Array,
            default: () => []
        }
    },
    validations: {
        form: {
            orNumber: { required },
            payor: { required },
            amount: { required },
        }
    },
    data() {
        return {
            form: {
                id: 0,
                orNumber: null,
                payor: null,
                particular: null,
                note: null,
                mode: null,
                checkNumber: null,
                checkDate: null,
                draweeBank: null,
                reference: null,
                fundSourceId: null,
                billingId: 0,
                amount: null,
                collectionItems: []
            },
            newAcc: {
                id: 0,
                fee: "",
                feeId: 0,
                amount: '',
                feeSearch: '',
                searched: false,
                failedSearch: false,
                editMode: false,
            },
            submitted: false,
            submitAcc: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: false,
            }),
            errorSearchRef: false,
        };
    },
    computed: {
        getTotalAmount(){
            return this.form.collectionItems.reduce((acc, item) => {
                return acc + parseFloat(item.amount ? this.getExactAmt(item.amount) : 0);
            }, 0);
        },
    },
    methods: {
        updateData(data){
            this.form = cloneDeep(data);
            this.form.checkDate = new Date(data.checkDate)
            this.form.amount = data.amount.toString();
        },
        resetForm() {
            this.form = {
                id: 0,
                orNumber: null,
                payor: null,
                particular: null,
                note: null,
                mode: 'Cash',
                checkNumber: null,
                checkDate: new Date(),
                draweeBank: null,
                reference: null,
                billingId: 0,
                amount: null,
                fundSourceId: null,
                collectionItems: []
            };
            this.newAcc = {
                id: 0,
                fee: "",
                feeId: 0,
                remarks: '',
                editMode: false,
            };
            this.$v.form.$reset();
            this.submitted = false;
        },
        searchFee(){
            this.fees.map(item => item.selected = false);
            this.$bvModal.show("fee-template-modal");
        },
        resetItem() {
            this.newAcc = {
                id: 0,
                fee: "",
                feeId: 0,
                amount: '',
                editMode: false,
            };
        },
        addSelectedFees(fees) {
            this.form.collectionItems.push(...fees.map(item => {
                return {
                    feeId: item.id,
                    fee: item.name,
                    amount: item.defaultAmount.toString(),
                    editMode: true,
                };
            }));
            this.resetItem();
            this.$bvModal.hide("fee-template-modal");
        },
        submitForm() {
            if(this.form.collectionItems.length == 0) return this.submitAcc = true;
            this.form.amount = this.getTotalAmount;
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            let data = cloneDeep(this.form);
            data.checkDate = this.form.checkDate ? this.getDate(this.form.checkDate) : null;
            data.dateReleased = this.form.dateReleased ? this.getDate(this.form.dateReleased) : null;
            data.collectionItems = this.form.collectionItems.map(item => {
                return {
                    feeId: item.feeId,
                    fee: item.fee,
                    amount: this.getExactAmt(item.amount),
                    remarks: item.remarks ? item.remarks : '',
                };
            });
            this.$emit("submit", data);
        },
        async addToCollection(){
            if(this.newAcc.feeId == 0 || this.newAcc.amount === '') return this.submitAcc = true;
            let dat = cloneDeep(this.newAcc);
            this.form.collectionItems.push(dat);
            this.resetItem();
            await this.wait(100);
            this.$refs.feeSearch.focus();
            this.submitAcc = false;
        },
        editItem(item) {
            item.editMode = true;
            item.cloneAmount = JSON.parse(JSON.stringify(item.amount));
        },
        cancelUpdate(item) {
            item.editMode = false;
            item.amount = JSON.parse(JSON.stringify(item.cloneAmount));
            delete item.cloneAmount;
        },
        deleteItem(index) {
            this.form.collectionItems.splice(index, 1);
        },
        updateForm(item) {
            if(!item.amount || item.amount === '0') return;
            item.editMode = false;
            delete item.cloneAmount;
        },
        resetSearch() {
            this.errorSearchRef = false;
        },
        async searchRefNo() {
            if(this.form.reference == '') return this.errorSearchRef = true;
            await this.$store
                .dispatch("billing/getBillingByReference", {body: this.form.reference})
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(!res.data){
                        this.errorSearchRef = true;
                    }else{
                        this.form.billingId = res.data.id;
                        this.form.collectionItems = res.data.billingDetails.map(item => {
                            return {
                                feeId: item.feeId,
                                fee: item.fee,
                                amount: item.amount.toString(),
                            };
                        });
                        this.form.payor = res.data.clientName;
                        this.form.amount = res.data.billingDetails.reduce((acc, item) => {
                            return acc + item.amount;
                        }, 0).toString();
                        this.errorSearchRef = false;
                    }
                })
            .catch((error) => {
                this.errorSearchRef = true;
            });
        },
        searchBilling() {
            this.$bvModal.show("unpaid-billing-modal");
            this.$refs.billingList.fetchUnpaidBillings();
        },
        setBilling(billing) {
            console.log(billing)
            this.form.billingId = billing.id;
            this.form.reference = billing.reference;
            this.form.payor = billing.clientName;
            this.form.collectionItems = billing.billingDetails.map(item => {
                return {
                    feeId: item.feeId,
                    fee: item.fee,
                    amount: item.amount.toString(),
                };
            });
            this.form.amount = billing.billingDetails.reduce((acc, item) => {
                return acc + item.amount;
            }, 0).toString();
            this.$bvModal.hide("unpaid-billing-modal");
        },
        resetBilling() {
            this.form.billingId = 0;
            this.form.reference = null;
            this.form.payor = null;
            this.form.collectionItems = [];
            this.searchBilling
            this.resetSearch();
        },
    }
};
</script>
<template>
    <b-modal
      size="xl"
      id="collection-modal"
      :title="modalTitle"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
        <div class="row">
            <div class="col-md-4 border-end">
                <div class="mb-2">
                    <label for="orNumber">OR Number</label>
                    <input
                        autocomplete="off"
                        id="orNumber"
                        v-model="form.orNumber"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': $v.form.orNumber.$error }"
                        required
                    />
                    <div v-if="$v.form.orNumber.$error" class="invalid-feedback">
                        OR Number is required
                    </div>
                </div>
                <template v-if="form.billingId == 0">
                    <div class="mb-2">
                        <label for="reference" class="mb-0">Reference</label>
                        <small class="d-block text-italic text-warning">*You can type ref no. or search from billing*</small>
                        <form @submit.prevent="searchRefNo">
                            <b-input-group>
                                <template #append>
                                    <b-button
                                        type="button"
                                        @click="searchBilling"
                                        variant="outline-info"
                                        ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                </template>
                                <input 
                                    autocomplete="off"
                                    id="reference" 
                                    v-model="form.reference" 
                                    type="text" 
                                    class="form-control" 
                                    :class="{'is-invalid': errorSearchRef}"/>
                            </b-input-group>
                            <div v-if="errorSearchRef" class="invalid-feedback">
                                {{ form.reference ? 'Reference not found' : 'Reference is required' }}
                            </div>
                        </form>
                    </div>
                    <div class="mb-2">
                        <label for="payor">Payor</label>
                        <input
                            id="payor"
                            v-model="form.payor"
                            autocomplete="off"
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && $v.form.payor.$error }"
                            required
                        />
                        <div v-if="$v.form.payor.$error" class="invalid-feedback">
                            Payor is required
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="rounded-3 px-2 py-2 border bg-success bg-soft mb-3">
                        <div class="text-green">#{{form.reference}}</div>
                        <div class="text-green font-weight-bold font-size-16">{{form.payor}}</div>
                        <div class="text-right">
                            <a @click="resetBilling" href="javascript:void(0)" class="text-warning d-flex align-items-center justify-content-end"><i class="bx bx-x"></i>Cancel</a>
                        </div>
                    </div>
                </template>
                <!-- <div class="mb-2">
                    <label for="amount">Amount</label>
                    <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="form.amount"
                        class="form-control me-1 text-right text-warning font-weight-bold"
                        :mask="currencyMask"
                        :class="{ 'is-invalid': submitted && $v.form.amount.$error }"
                    >
                    </masked-input>
                    <div v-if="submitted && $v.form.amount.$error" class="invalid-feedback">
                        Amount is required
                    </div>
                </div> -->
                <div class="mb-3">
                    <label for="mode">Fund Source</label>
                    <select 
                        class="form-select"
                        v-model="form.fundSourceId"
                    >
                        <option :value="null">Select Fund Source</option>
                        <option
                            v-for="x in fundSources"
                            :key="x.id"
                            :value="x.id"
                        >
                            {{ x.sourceName }}
                        </option>
                    </select>
                </div>
                <div class="mb-2">
                    <label for="mode">Payment Mode</label>
                    <select id="mode" v-model="form.mode" class="form-control">
                        <option value="Cash">Cash</option>
                        <option value="Check">Check</option>
                        <option value="ADA">ADA</option>
                    </select>
                </div>

                <template v-if="form.mode === 'Check'">
                    <div class="mb-2">
                        <label for="checkNumber">Check Number</label>
                        <input id="checkNumber" v-model="form.checkNumber" type="text" class="form-control" />
                    </div>
                    <div class="mb-2">
                        <label for="checkDate">Check Date</label>
                        <date-picker
                            id="checkDate"
                            v-model="form.checkDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Check Date..."
                            format="MMMM DD, YYYY"
                        >
                        </date-picker>
                    </div>
                    <div class="mb-2">
                        <label for="draweeBank">Drawee Bank</label>
                        <input id="draweeBank" v-model="form.draweeBank" type="text" class="form-control" />
                    </div>
                </template>
            </div>
            <div class="col-md-8">
                <div class="px-2 py-2 mb-2">
                    <div class="d-flex justify-content-between mb-2">
                        <p class="mb-0 text-white font-size-16">Collection Items:</p>
                        <p class="mb-0 text-warning font-weight-bold font-size-16">
                            Total: {{ formatCurrency(getTotalAmount) }}
                        </p>
                    </div>
                    <table class="table table-sm align-middle table-bordered border-primary mb-0">
                        <thead>
                            <tr>
                                <th>Fee</th>
                                <th class="text-center"  style="width:170px;">Amount</th>
                                <th class="text-center" style="width:90px;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in form.collectionItems">
                                <tr :key="`A${index}`">
                                    <td class="col-md-4">
                                        {{ item.fee }}
                                    </td>
                                    <td class="text-center">
                                        <template v-if="item.editMode">
                                            <form @submit.prevent="updateForm(item)">
                                                <masked-input
                                                    ref="accAmount"
                                                    autocomplete="off"
                                                    type="text"
                                                    v-model="item.amount"
                                                    class="form-control me-1 text-center form-control-sm"
                                                    :mask="currencyMask"
                                                >
                                                </masked-input>
                                            </form>
                                        </template>
                                        <template v-else>
                                            {{item.amount ? formatCurrency(getExactAmt(item.amount)) : '-'}}
                                        </template>
                                    </td>
                                    <td class="text-center col-md-1">
                                        <template v-if="item.editMode">
                                            <a href="javascript:void(0)" @click="updateForm(item)" >
                                                <i class="bx bx-check me-2 text-green font-size-24 font-weight-bold"></i>
                                            </a>
                                            <a href="javascript:void(0)" @click="cancelUpdate(item)" >
                                                <i class="bx bx-x text-danger font-size-24 font-weight-bold"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a href="javascript:void(0)" @click="editItem(item)">
                                                <i class="bx bx-edit text-success font-size-24 font-weight-bold"></i>
                                            </a>
                                            <a href="javascript:void(0)" @click="deleteItem(index)" >
                                                <i class="bx bx-trash text-danger font-size-24 font-weight-bold"></i>
                                            </a>
                                        </template>
                                    </td>
                                </tr>
                                <tr :key="`B${index}`">
                                    <td colspan="100%" class="py-0">
                                        <input type="text" class="form-control form-control-sm" v-model="item.remarks" :placeholder="`Remarks for ${item.fee}`" />
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <template v-if="!newAcc.feeId">
                                    <td>
                                        <form @submit.prevent="findAccount">
                                            <b-input-group>
                                                <template #append>
                                                    <b-button
                                                        type="button"
                                                        @click="searchFee"
                                                        variant="outline-info"
                                                        ><i class="mdi mdi-clipboard-text-search-outline"></i
                                                    ></b-button>
                                                </template>
                                                <input 
                                                    ref="feeSearch"
                                                    autocomplete="off"
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="Type the Fee Code or Click the search button" 
                                                    v-model="newAcc.feeSearch"
                                                    :class="{'is-invalid': newAcc.feeSearch && newAcc.failedSearch}"
                                                >
                                            </b-input-group>
                                            <span v-if="newAcc.feeSearch && newAcc.failedSearch">
                                                <small class="text-danger" v-if="newAcc.failedSearch">Account not found</small>
                                            </span>
                                        </form>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{newAcc.fee}}</td>
                                </template>
                                <td>
                                    <masked-input
                                        ref="accAmount"
                                        autocomplete="off"
                                        type="text"
                                        v-model="newAcc.amount"
                                        class="form-control me-1 text-center form-control-sm"
                                        :mask="currencyMask"
                                        :class="{'is-invalid': submitAcc && !newAcc.amount}"
                                    >
                                    </masked-input>
                                </td>
                                <td class="text-center">
                                    <template v-if="newAcc.feeId != 0 || newAcc.amount != ''">
                                        <a href="javascript:void(0)" @click="addToCollection" >
                                            <i class="bx bx-check me-2 text-green font-size-24 font-weight-bold"></i>
                                        </a>
                                        <a href="javascript:void(0)" @click="resetItem" >
                                            <i class="bx bx-x text-danger font-size-24 font-weight-bold"></i>
                                        </a>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="my-2">
                        <label for="particular">Particulars</label>
                        <textarea
                            rows="2"
                            id="particular"
                            v-model="form.particular"
                            type="text"
                            class="form-control"
                        ></textarea>
                    </div>
                    <div class="mb-2">
                        <label for="note">Note</label>
                        <textarea id="note" v-model="form.note" class="form-control" rows="3"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" @click="submitForm" class="btn btn-primary">
                <i class="bx bx-save me-1"></i>{{form.id == 0 ? 'Create' : 'Update'}} Collection
            </button>
            <button type="button" class="btn btn-link" @click="$bvModal.hide('collection-modal')">
                Close
            </button>
        </div>
        <FeeModal 
            :fees="fees"
            modalTitle="Select Fee"
            @selected-fees="addSelectedFees"
        />
        <BillingList 
            ref="billingList"
            @setBilling="setBilling"
        />
    </b-modal>
</template>